var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyntax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 2.41634L9.01302 2.04883L5.70537 13.584L6.98705 13.9515L10.2947 2.41634Z",
    fill: "#89A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27333 5.60671L3.33333 4.66671L0 8.00004L3.33333 11.3334L4.27333 10.3934L1.88667 8.00004L4.27333 5.60671Z",
    fill: "#89A6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7267 10.3934L12.6667 11.3334L16 8.00004L12.6667 4.66671L11.7267 5.60671L14.1133 8.00004L11.7267 10.3934Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyntax);
export default __webpack_public_path__ + "static/media/syntax.4ad125c472a02194ceda8e453b72bf54.svg";
export { ForwardRef as ReactComponent };